import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ThemePalette } from '@angular/material/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

import { LangSwitcherComponent } from '../../../shared/ui/lang-switcher/lang-switcher.component';
import { StateService } from '../../data-access/state.service';
import { AccessTokenService } from '../../data-access/access-token.service';
import { AuthOperation, Configuration } from '../../model/configurations.model';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    TranslateModule,
    LangSwitcherComponent,
    RouterModule,
    MatSlideToggleModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() authChange = new EventEmitter();

  accessTokenService = inject(AccessTokenService);
  private stateService = inject(StateService);
  private translate = inject(TranslateService);
  private renderer = inject(Renderer2);

  configurations$ = this.stateService.configurations$;
  isSideNavOpen$ = this.stateService.isSideNavOpen$;
  isTabletLandscapeUp$ = this.stateService.isTabletLandscapeUp$;
  title$ = this.stateService.selectedConfiguration$.pipe(
    map(({ title }) => title)
  );
  logoPath$ = this.stateService.selectedConfiguration$.pipe(
    map(({ logoFileName }) => `../assets/logos/${logoFileName}`)
  );
  isFullPageMode$ = this.stateService.isFullPageMode$;

  isDarkTheme = this.stateService.isDarkMode$.value;
  color: ThemePalette = 'accent';

  AuthOperation = AuthOperation;

  constructor() {
    this.toggleBodyClassForTheme(this.isDarkTheme);
  }

  ngOnInit() {
  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    this.stateService.isDarkMode$.next(this.isDarkTheme);
    this.toggleBodyClassForTheme(this.isDarkTheme);
  }

  toggleBodyClassForTheme(isDark: boolean) {
    if (isDark) {
      this.renderer.addClass(document.body, 'dark-theme');
    } else {
      this.renderer.removeClass(document.body, 'dark-theme');
    }
  }

  updateConfiguration(configuration: Configuration) {
    this.stateService.updateSelectedConfiguration(configuration);
  }

  changeAuth(operation: AuthOperation) {
    this.authChange.emit({ operation });
  }

  toggleSideNav(): void {
    this.stateService.toggleSideNav();
  }
}
